export const SET_SUPPLIER_RETURNS_LOADING = 'SET_SUPPLIER_RETURNS_LOADING';
export const SET_SUPPLIER_RETURNS = 'SET_SUPPLIER_RETURNS';
export const SET_SUPPLIER_RETURNS_FAILED = 'SET_SUPPLIER_RETURNS_FAILED';
export const SET_WE_OWE = 'SET_WE_OWE';
export const SET_SUPPLIER_RETURN_DOCUMENT = 'SET_SUPPLIER_RETURN_DOCUMENT';
